<div class="flex-row content-between">
    <div class="flex-row column ptb-10 plr-35 p-md-24 full">
        <div class="full d-flex-md content-center d-none mb-24 mt-10">
            <button type="button" class="height-4-px width-6 border-radius-8 tw-border-0 tw-p-0"
                style="background-color: #E9E9E9;" (click)="closeDialog()">
            </button>
        </div>
        <div class="flex-row align-center content-between mb-54 mb-md-32">
            <h2 class="fs-32 fw-8 color-202028 fs-md-18 full-md text-center-md">Transaction Details<p
                    class="fs-16 fw-7 pt-8 fs-md-14 pt-md-0 fw-md-4" *ngIf="data">+91{{data.number}}</p>
            </h2>
            <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0 d-none-md" (click)="closeDialog()"
                aria-label="Close dialog">
                <x-icon [iconColor]="'#4334EC'" [width]="'32px'" [height]="'32px'" class="cursor-pointer"
                    aria-hidden="true"></x-icon>
            </button>
        </div>
        <ng-container *ngIf="!isApp">
            <div class="flex-1 flex-row align-center column-gap-30 plr-24 ptb-12" style="background-color: #F4F3FF;">
                <p class="fw-7 width-20 width-ms-15">Date</p>
                <p class="fw-7 width-30 width-ms-28">Transaction ID</p>
                <p class="fw-7 width-20 width-ms-15">Amount </p>
            </div>
            <ng-container *ngFor="let trans of transactionDetail">
                <div class="flex-row align-center column-gap-30 plr-24 ptb-20 border-bottom-1">
                    <p class="width-20 width-ms-15">{{trans.date | date: 'dd MMM, y'}}</p>
                    <p class="width-30 width-ms-28">{{trans?.referencePaymentId|| '-'}}</p>
                    <p class="width-20 width-ms-15">{{trans.amount | currency: 'INR': 'symbol':'1.0-0'}}</p>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isApp">
            <div class="flex-row column row-gap-16 overflow-hidden overflow-y height-55 pb-70"
                *ngFor="let trans of transactionDetail">
                <div class="border-radius-8 flex-row column full row-gap-16 ptb-10 plr-16"
                    style="background-color: #F4F3FF;">
                    <div class="flex-row align-center content-between fs-14 color-202028">Amt <p class="fw-7">
                            {{trans.amount | currency: 'INR': 'symbol':'1.0-0'}}</p>
                    </div>
                    <div class="flex-row align-center content-between fs-14 color-202028">Txn. ID <p class="fw-7">
                            {{trans?.referencePaymentId || '-'}}</p>
                    </div>
                    <div class="flex-row align-center content-between fs-14 color-202028">Date <p class="fw-7">
                            {{trans.date | date: 'dd MMM, y'}}</p>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="position-fixed back-btn full d-none d-block-md bg-white ptb-12 plr-24 border-top-1" style="bottom: 0;">
        <button type="button" class="btn btn-primary full" (click)="closeDialog()">Go Back</button>
    </div>
</div>